import { ReduxAction } from "../types";

export type BillboardMessage = {
    id?: string;
    message: string;
    type?: "info" | "warn" | "success" | "error";
    sticky?: boolean;
    lifetime?: number;
    hidden?: boolean;
}
export interface DismissAction extends ReduxAction {
    type: "billboard.dismiss";
    payload: string;
}
export const dismissMessage:(m:string)=>DismissAction = (messageId:string) => ({
    type: "billboard.dismiss", 
    payload: messageId
});

export interface PublishAction extends ReduxAction {
    type: "billboard.publish";
    payload: BillboardMessage;
}
export const publishMessage:(m:BillboardMessage)=>PublishAction = (message:BillboardMessage) => ({
    type: "billboard.publish",
    payload:message
});

export interface HideAction extends ReduxAction {
    type: "billboard.hide";
    payload: string;
}
export const hideMessage:(m:string)=>HideAction = (messageId:string) => ({
    type: "billboard.hide",
    payload:messageId
});

export type BillboardAction = DismissAction | PublishAction | HideAction;